import { ActionTypes } from "./types";
import ReportsActions from "./actions";
import { useMemoOne } from "use-memo-one";
import reducer, { INITIAL_STATE } from "./reducer";
import React, { Children, useReducer, useContext, createContext } from "react";

const Context = createContext({
  dispatch: () => {},
  state: INITIAL_STATE,
});

const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  return (
    <Context.Provider value={{ state, dispatch }}>
      {Children.only(children)}
    </Context.Provider>
  );
};

export const useReportsState = () => {
  const { state, dispatch } = useContext(Context);
  const actions = useMemoOne(() => ReportsActions(dispatch), []);

  return {
    state,
    actions,
    dispatch,
  };
};

export default Provider;

export { ActionTypes };
